import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="border-t border-[#E9ECEF] mt-16 pt-6 pb-24 sm:pb-20 px-4 sm:px-8 max-w-7xl mx-auto"
      data-testid="site-footer"
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[#64748B] text-xs">
        <div className="flex items-center gap-2 flex-wrap">
          <img
            src="/rsell-logo.png"
            alt="rsell ai"
            className="h-4 w-auto select-none"
            style={{ filter: "invert(1) contrast(1.15) brightness(0.85)" }}
            draggable={false}
          />
          <span>· Lithuania, EU · <a href="mailto:rsell.ai.real@gmail.com" className="hover:text-[#0F172A] transition-colors">rsell.ai.real@gmail.com</a></span>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          <Link to="/about" data-testid="footer-about" className="hover:text-[#0F172A] transition-colors">About</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#0F172A] transition-colors">Privacy</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-[#0F172A] transition-colors">Terms</Link>
          <Link to="/refund-policy" data-testid="footer-refund" className="hover:text-[#0F172A] transition-colors">Refunds</Link>
        </nav>
      </div>
    </footer>
  );
}
